import * as z from 'zod/v4';

import { drawNumberSchema } from '../draw/entry.js';
import { dateTimeSchema } from '../frameworks/entry.js';
import { couponProductSchema } from '../product/entry.js';
import { activatedDrawIdSchema } from './activatedDrawId.js';

const maxCommissionSchema = z.string().transform((value) => {
  const normalized = value.replace(',', '.');
  const num = Number.parseInt(normalized, 10);
  if (num <= 0) {
    throw new Error('Must be a positive number');
  }
  return num;
});

const retailerActivatedDrawSchema = z.object({
  activatedDrawId: activatedDrawIdSchema,
  activatedDrawStatus: z.number(),
  activatedDrawDescription: z.string(),
  buyinCloseTime: dateTimeSchema,
  maxShares: z.number(),
  commissionPercent: z.number().min(0).max(10).brand<'Commission'>(),
  maxCommission: maxCommissionSchema,
  maxPlayableAmount: z.string(),
  numSharesRequired: z.number(),
  currentPlayableAmount: z.string(),
  drawNumber: drawNumberSchema,
  regCloseTime: dateTimeSchema,
  soldShares: z.number(),
  wagerSerial: z.string().nullable(),
  wagerAmount: z.string().nullable(),
  retailerCommission: z.string().nullable(),
  activatedDrawName: z.string(),
  isSubmittable: z.boolean(),
  subProductId: z.number(),
  description: z.string(),
  editorName: z.string(),
  numShares: z.number(),
  sharePrice: z.string(),
  containerId: z.number(),
  editorId: z.number(),
  groupId: z.number(),
  productId: couponProductSchema,
  name: z.string(),
});
export const retailerBalanceResponse = z.object({
  activatedDraw: retailerActivatedDrawSchema,
});

export type RetailerBalance = z.infer<typeof retailerBalanceResponse>;
export type RetailerBalanceResult = RetailerBalance | { activatedDraw: undefined };
